import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Typography, Button } from "@mui/material";
import NobetciEczaneAPI from "../../../apis/OB/Get/NobetciEczaneAPI";
import { today } from "../../../helpers/TodayDate";

// Eczane bilgilerini içeren bir tip tanımlayalım
interface Eczane {
  eczaneAdi: string;
  adres: string;
  telefon: string;
}

const NobetciEczaneler: React.FC = () => {
  useEffect(() => {
    fetchData();
  }, []);

  const [todayDate, setTodayDate] = useState<any>(today);

  const [nobetciEczaneListeDatas, setnobetciEczaneListeDatas] = useState<any[]>(
    []
  );

  const fetchData = async (isYesterday = false) => {
    try {
      let date;
      if (isYesterday === false) {
        date = new Date();
        setTodayDate(today.toString());
      } else {
        date = new Date();
        date.setDate(date.getDate() - 1);
        setTodayDate(date.toISOString().slice(0, 10));
      }

      const response = await NobetciEczaneAPI.getNobetciEczaneListe(date);
      setnobetciEczaneListeDatas(response.data);
    } catch (err) {
      // Hata yönetimi için burada bir şeyler yapabilirsiniz.
      console.error("Hata oluştu:", err);
    }
  };



  return (
    <div className="px-1 px-md-2 px-lg-4 py-3 w-100">
      <div className="p-0">
        <div className="d-flex justify-content-end gap-1 align-self-stretch mb-3 mt-1">
          <Button type="button" color="primary" onClick={() => fetchData(true)}>
            <i className="fa fa-angle-left"></i>
          </Button>
          <Button variant="outlined">{todayDate.toString()}</Button>
          <Button type="button" color="primary" onClick={() => fetchData()}>
            <i className="fa fa-angle-right"></i>
          </Button>
        </div>
        <Grid className="h-100" container spacing={2}>
          {nobetciEczaneListeDatas.length > 0 ? (
            nobetciEczaneListeDatas.map((eczane, index) => (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={index} style={{ display: 'flex' }}>
                <Card style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                  <CardContent style={{ flexGrow: 1 }}>
                    <Typography variant="h5">{eczane.eczaneAdi}</Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Adres: </span>
                      {eczane.adres}
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Telefon: </span>
                      {eczane.telefon}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <div
              className="d-flex align-items-center justify-content-center align-self-strech w-100"
              style={{ height: "20vh", fontSize: "1.5rem" }}
            >
              Kayıt Bulunamadı
            </div>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default NobetciEczaneler;
